/**
 * @fileoverview gRPC-Web generated client stub for grcexport
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: grcexport/grcexport.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.grcexport = require('./grcexport_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.grcexport.GrcExportClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.grcexport.GrcExportPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.grcexport.UploadFileRequest,
 *   !proto.grcexport.UploadFileResponse>}
 */
const methodDescriptor_GrcExport_UploadFile = new grpc.web.MethodDescriptor(
  '/grcexport.GrcExport/UploadFile',
  grpc.web.MethodType.UNARY,
  proto.grcexport.UploadFileRequest,
  proto.grcexport.UploadFileResponse,
  /**
   * @param {!proto.grcexport.UploadFileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.grcexport.UploadFileResponse.deserializeBinary
);


/**
 * @param {!proto.grcexport.UploadFileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.grcexport.UploadFileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.grcexport.UploadFileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.grcexport.GrcExportClient.prototype.uploadFile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/grcexport.GrcExport/UploadFile',
      request,
      metadata || {},
      methodDescriptor_GrcExport_UploadFile,
      callback);
};


/**
 * @param {!proto.grcexport.UploadFileRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.grcexport.UploadFileResponse>}
 *     Promise that resolves to the response
 */
proto.grcexport.GrcExportPromiseClient.prototype.uploadFile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/grcexport.GrcExport/UploadFile',
      request,
      metadata || {},
      methodDescriptor_GrcExport_UploadFile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.grcexport.GetUploadWizardRequest,
 *   !proto.grcexport.GetUploadWizardResponse>}
 */
const methodDescriptor_GrcExport_GetUploadWizard = new grpc.web.MethodDescriptor(
  '/grcexport.GrcExport/GetUploadWizard',
  grpc.web.MethodType.UNARY,
  proto.grcexport.GetUploadWizardRequest,
  proto.grcexport.GetUploadWizardResponse,
  /**
   * @param {!proto.grcexport.GetUploadWizardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.grcexport.GetUploadWizardResponse.deserializeBinary
);


/**
 * @param {!proto.grcexport.GetUploadWizardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.grcexport.GetUploadWizardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.grcexport.GetUploadWizardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.grcexport.GrcExportClient.prototype.getUploadWizard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/grcexport.GrcExport/GetUploadWizard',
      request,
      metadata || {},
      methodDescriptor_GrcExport_GetUploadWizard,
      callback);
};


/**
 * @param {!proto.grcexport.GetUploadWizardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.grcexport.GetUploadWizardResponse>}
 *     Promise that resolves to the response
 */
proto.grcexport.GrcExportPromiseClient.prototype.getUploadWizard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/grcexport.GrcExport/GetUploadWizard',
      request,
      metadata || {},
      methodDescriptor_GrcExport_GetUploadWizard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.grcexport.StartUploadWizardRequest,
 *   !proto.grcexport.StartUploadWizardResponse>}
 */
const methodDescriptor_GrcExport_StartUploadWizard = new grpc.web.MethodDescriptor(
  '/grcexport.GrcExport/StartUploadWizard',
  grpc.web.MethodType.UNARY,
  proto.grcexport.StartUploadWizardRequest,
  proto.grcexport.StartUploadWizardResponse,
  /**
   * @param {!proto.grcexport.StartUploadWizardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.grcexport.StartUploadWizardResponse.deserializeBinary
);


/**
 * @param {!proto.grcexport.StartUploadWizardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.grcexport.StartUploadWizardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.grcexport.StartUploadWizardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.grcexport.GrcExportClient.prototype.startUploadWizard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/grcexport.GrcExport/StartUploadWizard',
      request,
      metadata || {},
      methodDescriptor_GrcExport_StartUploadWizard,
      callback);
};


/**
 * @param {!proto.grcexport.StartUploadWizardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.grcexport.StartUploadWizardResponse>}
 *     Promise that resolves to the response
 */
proto.grcexport.GrcExportPromiseClient.prototype.startUploadWizard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/grcexport.GrcExport/StartUploadWizard',
      request,
      metadata || {},
      methodDescriptor_GrcExport_StartUploadWizard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.grcexport.ResetUploadWizardRequest,
 *   !proto.grcexport.ResetUploadWizardResponse>}
 */
const methodDescriptor_GrcExport_ResetUploadWizard = new grpc.web.MethodDescriptor(
  '/grcexport.GrcExport/ResetUploadWizard',
  grpc.web.MethodType.UNARY,
  proto.grcexport.ResetUploadWizardRequest,
  proto.grcexport.ResetUploadWizardResponse,
  /**
   * @param {!proto.grcexport.ResetUploadWizardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.grcexport.ResetUploadWizardResponse.deserializeBinary
);


/**
 * @param {!proto.grcexport.ResetUploadWizardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.grcexport.ResetUploadWizardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.grcexport.ResetUploadWizardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.grcexport.GrcExportClient.prototype.resetUploadWizard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/grcexport.GrcExport/ResetUploadWizard',
      request,
      metadata || {},
      methodDescriptor_GrcExport_ResetUploadWizard,
      callback);
};


/**
 * @param {!proto.grcexport.ResetUploadWizardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.grcexport.ResetUploadWizardResponse>}
 *     Promise that resolves to the response
 */
proto.grcexport.GrcExportPromiseClient.prototype.resetUploadWizard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/grcexport.GrcExport/ResetUploadWizard',
      request,
      metadata || {},
      methodDescriptor_GrcExport_ResetUploadWizard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.grcexport.LinkControlToExternalRequest,
 *   !proto.grcexport.LinkControlToExternalResponse>}
 */
const methodDescriptor_GrcExport_LinkControlToExternal = new grpc.web.MethodDescriptor(
  '/grcexport.GrcExport/LinkControlToExternal',
  grpc.web.MethodType.UNARY,
  proto.grcexport.LinkControlToExternalRequest,
  proto.grcexport.LinkControlToExternalResponse,
  /**
   * @param {!proto.grcexport.LinkControlToExternalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.grcexport.LinkControlToExternalResponse.deserializeBinary
);


/**
 * @param {!proto.grcexport.LinkControlToExternalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.grcexport.LinkControlToExternalResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.grcexport.LinkControlToExternalResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.grcexport.GrcExportClient.prototype.linkControlToExternal =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/grcexport.GrcExport/LinkControlToExternal',
      request,
      metadata || {},
      methodDescriptor_GrcExport_LinkControlToExternal,
      callback);
};


/**
 * @param {!proto.grcexport.LinkControlToExternalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.grcexport.LinkControlToExternalResponse>}
 *     Promise that resolves to the response
 */
proto.grcexport.GrcExportPromiseClient.prototype.linkControlToExternal =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/grcexport.GrcExport/LinkControlToExternal',
      request,
      metadata || {},
      methodDescriptor_GrcExport_LinkControlToExternal);
};


module.exports = proto.grcexport;

